import React from 'react'

const ShowImportModal = ({resetImportModal, isImporting, selectedFile, handleFileSelect, fileError, handleImportContacts, fileInputRef, handleFileChange}) => {
  return (
    <div className="fixed inset-0 bg-[#000000] bg-opacity-50 backdrop-blur-[15px] flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Import Contacts
              </h3>
              <button
                onClick={resetImportModal}
                className="text-gray-400 hover:text-gray-600 text-2xl"
                disabled={isImporting}
              >
                ×
              </button>
            </div>
            
            <div className="mb-6">
              <p className="text-gray-600 mb-4">
                Upload a CSV file to import contacts into your database.
              </p>
              
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                {!selectedFile ? (
                  <div>
                    <svg className="mx-auto h-12 w-12 text-gray-400 mb-4" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                      <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <button
                      onClick={handleFileSelect}
                      className="px-4 py-2 bg-[#3985b6] text-white rounded-lg hover:bg-[#2b6a94] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-200"
                      disabled={isImporting}
                    >
                      Upload CSV File
                    </button>
                    <p className="text-gray-500 text-sm mt-2">Select a CSV file from your computer</p>
                  </div>
                ) : (
                  <div>
                    <svg className="mx-auto h-12 w-12 text-green-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <p className="text-gray-700 font-medium mb-2">Selected File:</p>
                    <p className="text-blue-600 font-semibold">{selectedFile.name}</p>
                    <p className="text-gray-500 text-sm mt-1">
                      Size: {(selectedFile.size / 1024).toFixed(2)} KB
                    </p>
                    <button
                      onClick={handleFileSelect}
                      className="mt-3 px-3 py-1 text-sm text-blue-600 border border-blue-600 rounded hover:bg-blue-50 transition-all duration-200"
                      disabled={isImporting}
                    >
                      Choose Different File
                    </button>
                  </div>
                )}
              </div>
              {fileError && (
                <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-red-600 text-sm font-medium">{fileError}</p>
                </div>
              )}
            </div>
            
            <div className="flex justify-end gap-3">
              <button
                onClick={resetImportModal}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-all duration-200"
                disabled={isImporting}
              >
                Cancel
              </button>
              <button
                onClick={handleImportContacts}
                disabled={!selectedFile || isImporting || fileError}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-all duration-200"
              >
                {isImporting && (
                  <div className="animate-spin h-4 w-4 border-t-2 border-white rounded-full"></div>
                )}
                {isImporting ? 'Uploading...' : 'Upload File'}
              </button>
            </div>
            
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept=".csv"
              className="hidden"
            />
          </div>
        </div>
  )
}

export default ShowImportModal
